type PriorTag = {tag?: string | null; source?: string | null; changed_at?: string | null};
type TaggedAnimal = {id?: string; tag?: string | null; old_tags?: PriorTag[] | null};

export function preservePreviousTag(
  animal: TaggedAnimal,
  nextTag: string | null,
  changedAt = new Date().toISOString(),
): PriorTag[] {
  const prior = animal.old_tags || [];
  if (!animal.tag || animal.tag === nextTag || prior.some((t) => t.tag === animal.tag && t.source !== 'import')) {
    return prior;
  }
  return [...prior, {tag: animal.tag, source: 'manual', changed_at: changedAt}];
}

// The weigh-in composition the webform retag and the session-page swap apply
// to old_tags for their LOCAL reflect (the audited retag operation composes
// the same shape server-side; H1: both are driven by the tag the operator
// typed). Exported so the parity oracle runs the client's real function.
export function composeWeighInTagHistory(
  oldTags: PriorTag[] | null | undefined,
  priorTag: string,
  changedAt = new Date().toISOString(),
): PriorTag[] {
  const existing = Array.isArray(oldTags) ? oldTags : [];
  const index = existing.findIndex((t) => String(t && t.tag) === priorTag);
  if (index >= 0) {
    const current = existing[index] || {};
    if (current.source !== 'weigh_in') {
      return existing.map((t, i) => (i === index ? {...t, tag: priorTag, source: 'weigh_in'} : t));
    }
    return existing;
  }
  return existing.concat([{tag: priorTag, source: 'weigh_in', changed_at: changedAt}]);
}
